import { cx } from '@emotion/css';
import { Row } from 'antd';
import { useAccountSelector } from 'src/hooks';
import { MCollapse } from 'src/lib';
import { Heading, Spacing } from 'src/styles';

import { OtherAccountHolderDisclosureSection } from './OtherAccountHolderDisclosureSection';

export const OtherAccountHolderListDisclosureSection = () => {
  const { account } = useAccountSelector();

  const getOptionList = () => {
    return (
      account?.otherAccountHolders?.map((holder, index) => ({
        id: holder.id,
        header: `Authorized Signer ${index + 3}`,
        content: <OtherAccountHolderDisclosureSection accountHolder={holder} />,
      })) || []
    );
  };

  const findDefaultActiveKey = () => {
    return account?.otherAccountHolders && account.otherAccountHolders?.length > 0
      ? account?.otherAccountHolders[0].id
      : undefined;
  };

  return (
    <>
      <Row className={cx(Heading.title, Spacing.my32)} data-testid={'other-account-holder-list-section'}>
        Other Authorized Signers
      </Row>
      <MCollapse defaultActiveKey={findDefaultActiveKey()} optionList={getOptionList()} />
    </>
  );
};
